import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RouterUrlsEnum } from '../../enums/router-urls.enum';

@Component({
  standalone: true,
  selector: 'bodyanalytics-signup-button',
  templateUrl: './signup-button.component.html',
})
export class SignupButtonComponent {
  private router = inject(Router);

  protected registerLink = RouterUrlsEnum.AUTH_REGISTER_ACCOUNT;

  public register() {
    // this.router.navigateByUrl(`${RouterUrlsEnum.AUTH_REGISTER_ACCOUNT}`);
    this.router.navigate([`${this.registerLink}`]);
  }
}
